/**
 * Argus — TURN credentials client.
 *
 * Bloc turn-server-secure-creds 2026-05-11. Fetch ephemeral HMAC-SHA1 creds de la PHP backend
 * (`GET /api/v1/me/turn-credentials`). Cache local cu TTL-1min safety margin pentru a forţa
 * re-fetch ÎNAINTE de expire real coturn (clock skew + network latency setup).
 *
 * Pattern RFC 7635 TURN REST API:
 *   username = "<expirationEpoch>:<userIdHex>"
 *   credential = base64(HMAC-SHA1(username, staticAuthSecret))
 * Coturn validează HMAC server-side cu secret share. Scannere fără secret = 401.
 *
 * Fallback graceful: dacă endpoint fail / 401, returnăm `[STUN_FALLBACK]` doar → WebRTC behavior
 * back-compat STUN-only (NU regressed faţă de v1.0.30 pre-bloc).
 */

import { apiFetch } from './api';

const STUN_URL = 'stun:165.232.81.235:3478';
const STUN_FALLBACK: RTCIceServer = { urls: STUN_URL };

interface TurnCredentialsResponse {
  username: string;
  credential: string;
  ttl: number;
  urls: string[];
}

interface IceServersCache {
  servers: RTCIceServer[];
  expiresAt: number;
}

let cache: IceServersCache | null = null;

export async function getIceServers(): Promise<RTCIceServer[]> {
  const now = Date.now();
  if (cache !== null && now < cache.expiresAt - 60_000) {
    return cache.servers;
  }
  try {
    const resp = await apiFetch<TurnCredentialsResponse>('/api/v1/me/turn-credentials');
    if (resp.data && resp.data.username && resp.data.credential && Array.isArray(resp.data.urls)) {
      const turnServer: RTCIceServer = {
        urls: resp.data.urls,
        username: resp.data.username,
        credential: resp.data.credential,
      };
      cache = {
        servers: [STUN_FALLBACK, turnServer],
        expiresAt: now + resp.data.ttl * 1000,
      };
      console.log(`[turn] creds fetched ttl=${resp.data.ttl}s urls=${resp.data.urls.join(',')}`);
      return cache.servers;
    }
  } catch (err) {
    console.warn('[turn] creds fetch failed; falling back STUN-only', err);
  }
  return [STUN_FALLBACK];
}

/**
 * Invalidate cache forced — folosit la logout / re-auth pentru a forţa fetch fresh la următoarea
 * deschidere webcam modal.
 */
export function clearIceServersCache(): void {
  cache = null;
}
